import { render, staticRenderFns } from "./FacialDeviceForm.vue?vue&type=template&id=9ffcb480&scoped=true&"
import script from "./FacialDeviceForm.vue?vue&type=script&lang=js&"
export * from "./FacialDeviceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffcb480",
  null
  
)

export default component.exports